export const TYPE = ['default', 'secondary'];

export const dispatchClassName = ({ value, disabled, type } = {}) => {
  if (disabled) {
    return {
      background: 'bg-disabled',
      border: 'border-default',
    };
  }

  if (value) {
    const dispatch = {
      default: {
        background: 'bg-brand-primary-base',
        border: 'border-transparent',
      },
      secondary: {
        background: 'bg-brand-secondary-base',
        border: 'border-transparent',
      },
    };

    return dispatch?.[type];
  }

  return {
    background: 'bg-light',
    border: 'border-default',
  };
};
